import { Controller } from "@hotwired/stimulus";

// Generic nested-form controller for `accepts_nested_attributes_for` rows
// (positions on elections, votes on ballots, etc.).
//
// HTML wiring:
//   <div data-controller="nested-form">
//     <div data-nested-form-target="container">…existing rows…</div>
//     <template data-nested-form-target="template">…blank row…</template>
//     <button data-action="nested-form#add">Add</button>
//   </div>
//
// Each row:
//   <div data-nested-form-target="entry">
//     <input type="hidden" name="…[_destroy]" data-nested-form-target="destroy">
//     <button data-action="nested-form#remove">Remove</button>
//   </div>
//
// Template fields use NEW_INDEX as the child_index placeholder; it's
// substituted with Date.now() on add so each new row gets a unique key.
export default class extends Controller {
  static targets = ["container", "template", "entry", "destroy"];

  add(event) {
    event.preventDefault();

    const content = this.templateTarget.innerHTML;
    const index = Date.now();
    const newEntry = content.replace(/NEW_INDEX/g, index);

    this.containerTarget.insertAdjacentHTML("beforeend", newEntry);
  }

  remove(event) {
    event.preventDefault();

    const entry = this.entryTargets.find((el) => el.contains(event.target));
    if (!entry) return;

    const destroyField = entry.querySelector('[data-nested-form-target="destroy"]');
    if (destroyField) {
      destroyField.value = "1";
      entry.style.display = "none";
    } else {
      entry.remove();
    }
  }
}
